export const enum EContractorType {
  Supplier = 'Supplier',
  Buyer = 'Buyer',
}
